import { Component, OnInit, Input } from '@angular/core';
import { CompanySettingsData } from '../../interfaces';

@Component({
  selector: 'app-employee-titles',
  templateUrl: './employee-titles.component.html',
  styleUrls: ['./employee-titles.component.scss']
})
export class EmployeeTitlesComponent implements OnInit {
  @Input() titles: CompanySettingsData[] = [];

  constructor() {}

  ngOnInit(): void {}
}
